export default __webpack_public_path__ + "static/media/2.7e969f49.webp";